module.exports = __webpack_public_path__ + "img/solution3_chart2.bdf813e3.png";